import { apiHelper } from '@/utils'
import { API } from '@/constants'

export const approvalService = {
  getAllApprovals, getApproval, createApproval, approveApproval, rejectApproval, deleteApproval, getPendingCount, updateApprovalPayload,
}

const API_URL = API.BASE_URL + '/v1'

function buildParams(filter) {
  const params = { page: filter?.pageNumber, size: filter?.pageSize }
  if (filter?.status) params.status = filter.status
  if (filter?.docType) params.doc_type = filter.docType
  if (filter?.action) params.action = filter.action
  filter?.searchArray?.forEach((w, i) => {
    if (w !== null && w !== '') params[`search_words[${i}]`] = w
  })
  return params
}

/** The badge count, without serialising every pending row to get it. */
export function getPendingCount() {
  return apiHelper(API_URL).get('/approvals/pending-count')
}

export function getAllApprovals(filter) {
  return apiHelper(API_URL).get('/approvals', { params: buildParams(filter) })
}
export function getApproval(uuid) {
  return apiHelper(API_URL).get(`/approvals/${uuid}`)
}
export function createApproval(data) {
  return apiHelper(API_URL).post('/approvals', data)
}
/** Rewrite the document waiting to be approved. */
export function updateApprovalPayload(uuid, data) {
  return apiHelper(API_URL).patch(`/approvals/${uuid}/payload`, data)
}
export function approveApproval(uuid, data) {
  return apiHelper(API_URL).patch(`/approvals/${uuid}/approve`, data || {})
}
export function rejectApproval(uuid, data) {
  return apiHelper(API_URL).patch(`/approvals/${uuid}/reject`, data || {})
}
/** Throw the request away. Only one the ledger never posted. */
export function deleteApproval(uuid) {
  return apiHelper(API_URL).delete(`/approvals/${uuid}`)
}
